var OutcomesProgress = {
    currentItem: [],
    currentSelect: '',
    currentProperty: '',
    deletedId: '',
    newItemId:'',


    init: function () {
        OutcomesProgress.bindAddProperty();
        OutcomesProgress.bindManageOutcomesProgressPropertyButtons();
        OutcomesProgress.bindManagePropertySave();
        OutcomesProgress.bindDelete();
        OutcomesProgress.bindCancel();
        OutcomesProgress.bindSubmit();
        OutcomesProgress.bindPupilSearch();
    },

    bindAddProperty: function() {
        console.log('binding outcomes progress property add');
        $('.outcomes-progress-property-add').click(function(e) {
            var property = $(this).data('property');
            var name = $('#' + property).val();
            if (property == 'need') {
                var translatedProperty = translatedNeed;
            } else if (property == 'topic') {
                var translatedProperty = translatedTopic;
            } else if (property == 'status') {
                var translatedProperty = translatedStatus;
            }
            OutcomesProgress.currentProperty = property;
            $.get('/outcomes-progress/' + property + '/add?name=' + name + '&property=' + property, function(data) {
                if (data.success) {
                    alert(translatedProperty + ' added successfuly!');
                    $('#' + property + '-modal').modal('hide');
                    OutcomesProgress.bindPropertySelect();
                } else {
                    alert('Action not successful, please try again.');
                }
            });
        });
    },

    bindCancel: function() {
        $('.delete-cancel').click(function() {
            OutcomesProgress.toggleManageModal(false);
        });
    },

    bindDelete: function() {
        $('.outcomes-progress-property-delete').click(function() {
            if (!$(this).hasClass('confirm')) {
                OutcomesProgress.toggleManageModal(true);
                return;
            }
            var originalId = OutcomesProgress.currentItem['id'];
            var property = OutcomesProgress.currentProperty;
            var newId = $('#manage-' + property + '-select').val();
            OutcomesProgress.newItemId = newId;
            if (property == 'need') {
                var translatedProperty = translatedNeed;
            } else if (property == 'topic') {
                var translatedProperty = translatedTopic;
            } else if (property == 'status') {
                var translatedProperty = translatedStatus;
            }
            $.get('/outcomes-progress/' + property + '/delete?original_id=' + originalId + '&new_id=' + newId +
                '&property=' + property, function(data) {
                if (data.success) {
                    alert(translatedProperty + ' successfully deleted.');
                    $('#manage-' + property + '-modal').modal('hide');
                    OutcomesProgress.deletedId = originalId;
                    OutcomesProgress.bindPropertySelect();
                    return;
                }
                alert('Action not successful. Please try again.');
            })
        });
    },

    bindManageOutcomesProgressPropertyButtons: function() {
        $('.manage-outcomes-progress-property').click(function() {
            OutcomesProgress.setDropdownInModal($(this));
        });
    },

    setDropdownInModal: function(manageButton) {
        var selectId = manageButton.data('select');
        var property = manageButton.data('property');
        OutcomesProgress.currentProperty = property;
        if (property == 'need') {
            var translatedProperty = translatedNeed;
        } else if (property == 'topic') {
            var translatedProperty = translatedTopic;
        } else if (property == 'status') {
            var translatedProperty = translatedStatus;
        }
        var typeSelect = $('#manage-' + property+ '-select');
        var propertyElement =  $('#manage-' + property + '-name');
        propertyElement.val('').attr('placeholder', 'New name');
        var select = $('#' + selectId);
        var option = select.find(':selected');
        OutcomesProgress.currentItem['id'] = option.val();
        OutcomesProgress.currentItem['name'] = option.text();
        $('#manage-' + property + '-title').html('Manage ' + translatedProperty + ': ' + OutcomesProgress.currentItem['name']);
        typeSelect.find('option').attr('disabled', false);
        typeSelect.find('option[value="' + OutcomesProgress.currentItem['id'] +'"]').attr('disabled', true);
    },

    toggleManageModal: function(remove) {
        var property = OutcomesProgress.currentProperty;
        if (property == 'need') {
            var translatedProperty = translatedNeed;
        }
        if (property == 'topic') {
            translatedProperty = translatedTopic;
        }
        if (property == 'status') {
            translatedProperty = translatedStatus;
        }
        var selector = 'select';
        if (remove) {
            var deleteBtn = $('#'+ property +'-delete');
            deleteBtn.removeClass('btn-secondary').addClass('btn-danger').addClass('confirm').html('<i class="fa fa-trash" aria-hidden="true"></i> Confirm');
            /*
            $('#' + property + '-delete-text').html('Select a new ' + translatedProperty + ' to move ' + translatedTarget + 's  with this ' + translatedProperty + ' to.').show();
            */
            $('#' + property + '-delete-text').html('Select a new ' + translatedProperty + ' to move ' + translatedProperty + ' with this ' + translatedProperty + ' to.').show();
            $('#manage-' + property + '-' + selector + '-container').slideDown('fast');
            $('#manage-' + property + '-name').slideUp('fast');
            $('#' + property + '-delete-cancel').show();
            $('#manage-' + property + '-save').hide();
            return;
        }
        $('#' + property + '-delete').removeClass('btn-danger').addClass('btn-secondary').removeClass('confirm').html('<i class="fa fa-trash" aria-hidden="true"></i> Delete');
        $('#' + property + '-delete-text').html('').hide();
        $('#manage-' + property + selector + '-container').slideUp('fast');
        $('#manage-' + property + '-name').slideDown('fast');
        $('#' + property + '-delete-cancel').hide();
        $('#manage-' + property + '-save').show();
    },

    bindManagePropertySave: function() {
        $('.outcomes-progress-property-save').click(function() {
            var property = OutcomesProgress.currentProperty;
            var nameInput = $('#manage-' + property + '-name');
            if (nameInput.val() != '') {
                // ??? where is select subsequently used ???
                var select = $('#manage-' + property + '-select');
                var name = nameInput.val();
                var id = OutcomesProgress.currentItem['id'];
                if (property == 'need') {
                    var translatedProperty = translatedNeed;
                } else if (property == 'topic') {
                    var translatedProperty = translatedTopic;
                } else if (property == 'status') {
                    var translatedProperty = translatedStatus;
                }
                name = encodeURIComponent(name);
                $.get('/outcomes-progress/' + property + '/rename?id=' + id + '&name=' + name +
                    '&property=' + property, function(res) {
                    if (res.success) {
                        alert(translatedProperty + ' updated successfully!');
                        nameInput.val('');
                        $('#manage-' + property +' -modal').modal('hide');
                        OutcomesProgress.bindPropertySelect();
                        return;
                    }
                    alert('Action not successful. Please try again.');
                });
            }
        });
    },

    bindPropertySelect: function () {
        var property = OutcomesProgress.currentProperty;
        var selects = $('.outcomes-progress-statuses');
        var url = '/outcomes-progress/statuses';
        if (property == 'status') {
            var translatedProperty = translatedStatus + 'es';
        } else if (property == 'need') {
            selects = $('.outcomes-progress-needs');
            url = '/outcomes-progress/needs';
            var translatedProperty = translatedNeed + 's';
        }
        $.get(url, function(propertyItems) {
            var manageSelect = $('#manage-'+ property +'-select');
            manageSelect.empty();
            propertyItems = App.sortProperties(propertyItems, false);
            for (var x = 0; x < selects.length; x++) {
                var select = $(selects[x]);
                var currentId = select.val();
                select.empty();
                var item = '<option value="" selected disabled>Click to see list of ' +  translatedProperty  + '</option>';
                select.append(item);
                for (var z = 0; z < propertyItems.length; z++) {
                    var selectOption = '';
                    var disabled = '';
                    var propertyItem = propertyItems[z];
                    if (propertyItem[0] == currentId || (OutcomesProgress.deletedId == currentId && propertyItem[0] == OutcomesProgress.newItemId)) {
                        selectOption = 'selected';
                        // disabled = 'disabled';
                    }
                    item = '<option value="'+ propertyItem[0] +'"' + selectOption + '>'+ propertyItem[1] +'</option>';
                    select.append(item);
                    // item = '<option value="'+ focusArea[0] +'"' + selectOption + ' ' + disabled + '>'+ focusArea[1] +'</option>';
                    if (x < 1) {
                        manageSelect.append(item);
                    }
                }
            }
            OutcomesProgress.deletedId = '';
        });
    },

    bindPupilSearch: function() {
        $('#outcomes-progress-pupil-search').select2({
            ajax: {
                url: '/admin/pupils/ajax',
                placeholder: 'Search by Pupil Name',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    };
                },
                results: function (data, page) {
                    return { results: data.results };
                },
            },
            minimumInputLength: 3
        }).on('select2:select', function(e) {
            window.location.href = '/outcomes-progress?pupil=' + $(this).select2('data')[0].id;
        });
    },

   bindSubmit: function() {
        $('#outcomes-progress-submit').click(function(e) {
            /* this makes Outcome textarea mandatory
            var stop = false;
            $('.outcomes-progress-name').each(function(index) {
                //if ($(this).is(':empty')) {
                if ($(this).val() == '') {
                    stop = true;
                    alert('Please name all outcomes before continuing.');
                }
            });
            if (stop) {
                e.preventDefault();
            }
            */
            var select = $('#outcomes-progress-pupil');
            var noPupil = select.val() === undefined || select.val() == '' || select.val() == null;
            var noStatus = false;
            $('[id^=status-]').each(function() {
                var id = $(this).attr('id');
                if (/status-\d+/.test(id)) {
                    select = $(this);
                    if (!noStatus) {
                        noStatus = select.val() === undefined || select.val() == '' || select.val() == null || select.val() == 0;
                    }
                    if (noStatus) {
                        return false;
                    }
                }
            });
            var noNeed = false;
            $('[id^=need-]').each(function() {
                var id = $(this).attr('id');
                if (/need-\d+/.test(id)) {
                    select = $(this);
                    if (!noNeed) {
                        noNeed = select.val() === undefined || select.val() == '' || select.val() == null || select.val() == 0;
                    }
                    if (noNeed) {
                        return false;
                    }
                }
            });
            if (noPupil || noNeed || noStatus) {
                e.preventDefault();
                switch (true) {
                    case noPupil:
                        alert('Please select a pupil before continuing.');
                        break;
                    case noNeed:
                        alert('Please select a Need for each Outcome before continuing.');
                        break;
                    case noStatus:
                        alert('Please select a Status for each Outcome before continuing.');
                        break;
                    default:
                        break;
                }
            } else {

                var textareaContent = true;
                if (textareaContent) {
                    var btn = $(this);
                    var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
                    var form = $('#outcomesProgressFormForm');
                    var data = form.serialize();
                    var url = form.attr('action');

                    btn.html(html);
                    form.submit(function() {
                        $('#outcomes-progress-submit').prop('disabled', true);
                    });
                }
            }
        });
    },

};

